import { styled } from '@mui/material/styles';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import TextInput from '../../forms/TextInput';
import Checkbox from '../../forms/Checkbox';

const PREFIX = 'ParentOrganizationForm';

const classes = {
  container: `${PREFIX}-container`,
  title: `${PREFIX}-title`,
  paper: `${PREFIX}-paper`,
  form: `${PREFIX}-form`,
  purpose: `${PREFIX}-purpose`,
  subctrl: `${PREFIX}-subctrl`,
  addButton: `${PREFIX}-addButton`,
  mapWrapper: `${PREFIX}-mapWrapper`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    marginLeft: theme.spacing(2),
  },

  [`& .${classes.title}`]: {
    fontFamily: 'Bitter',
    fontWeight: 700,
    fontSize: 21,
  },

  [`& .${classes.paper}`]: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  [`& .${classes.form}`]: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(1),
    gap: theme.spacing(2),
    width: 500,
  },

  [`& .${classes.purpose}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },

  [`& .${classes.subctrl}`]: {
    marginLeft: theme.spacing(4),
  },

  [`& .${classes.addButton}`]: {
    marginBottom: theme.spacing(2),
  },
}));

interface ProfileFormProps {
  isNew: boolean;
  formHook: UseFormReturn<any, any>;
}

export default function ParentOrganizationForm({
  isNew,
  formHook,
}: ProfileFormProps) {
  const { t } = useTranslation('common');
  const requiredFieldMessage = t('common.requiredField');

  const { control, formState } = formHook;

  return (
    <StyledBox className={classes.container}>
      <Box className={classes.form}>
        <TextInput
          name="parentOrganizationName"
          label={t('parentOrganizations.name')}
          control={formHook.control}
          required={true}
          disabled={false}
          rules={{ required: requiredFieldMessage }}
        />
        <TextInput
          name="parentOrganizationBC"
          label={t('parentOrganizations.bc')}
          control={formHook.control}
          required={true}
          disabled={!isNew}
          rules={{ required: requiredFieldMessage }}
        />
        <Checkbox
          name="isInternal"
          label={t('parentOrganizations.internalClient')}
          control={formHook.control}
        />
      </Box>
    </StyledBox>
  );
}
